import React from 'react';
import { Box, IconButton, Tooltip, Typography } from '@mui/material';
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import CloseIcon from '@mui/icons-material/Close';
import { MESSENGER } from './messengerTheme';

interface MessengerHeaderProps {
  title: React.ReactNode;
  onClose: () => void;
  onBack?: () => void;
  /** Ações extras à direita, antes do fechar. */
  actions?: React.ReactNode;
  /** Conteúdo abaixo do título (ex.: busca da aba Ajuda). */
  children?: React.ReactNode;
  align?: 'center' | 'left';
}

const MessengerHeader: React.FC<MessengerHeaderProps> = ({ title, onClose, onBack, actions, children, align = 'center' }) => (
  <Box sx={{ borderBottom: `1px solid ${MESSENGER.border}`, bgcolor: MESSENGER.surface, flexShrink: 0 }}>
    <Box sx={{ display: 'flex', alignItems: 'center', minHeight: 56, px: 1, gap: 0.5 }}>
      <Box sx={{ width: 40, display: 'flex', justifyContent: 'center', flexShrink: 0 }}>
        {onBack && (
          <Tooltip title="Voltar">
            <IconButton size="small" onClick={onBack} aria-label="Voltar" sx={{ color: MESSENGER.navy }}>
              <ArrowBackIosNewIcon sx={{ fontSize: 16 }} />
            </IconButton>
          </Tooltip>
        )}
      </Box>
      <Box sx={{ flex: 1, minWidth: 0, textAlign: align }}>
        {typeof title === 'string' ? (
          <Typography noWrap sx={{ fontWeight: 700, fontSize: '1rem', color: MESSENGER.navy }}>
            {title}
          </Typography>
        ) : (
          title
        )}
      </Box>
      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end', minWidth: 40, flexShrink: 0 }}>
        {actions}
        <Tooltip title="Fechar">
          <IconButton size="small" onClick={onClose} aria-label="Fechar" sx={{ color: MESSENGER.slate }}>
            <CloseIcon sx={{ fontSize: 20 }} />
          </IconButton>
        </Tooltip>
      </Box>
    </Box>
    {children && <Box sx={{ px: 2, pb: 1.5 }}>{children}</Box>}
  </Box>
);

export default MessengerHeader;
